<template>
  <ion-page class="reading">
    <page-white-background title="阅读理解" router-type="modal" @router-back="onClose">
      <template #default>
        <div class="reading_page">
          <div style="display: flex; justify-content: space-between">
            <ion-searchbar
              class="search-bar"
              placeholder="搜索文章标题"
              @ionChange="searchReadingArticle"
            >
            </ion-searchbar>
            <!--            <i class="iconfont icon-zhedie" @click="openCourseModel"></i>-->
          </div>
          <div
            v-for="(item, index) in dataList"
            :key="index"
            class="reading_page-card mb-5 mt-3"
            @click="openReadingArticle(item)"
          >
            <div class="flex-row justify-between align-center mb-2">
              <div class="flex-row align-center">
                <!--                <img class="icon mr-1" :src="getBrandImageUrl('reading/note_icon.png')" alt="" />-->
                <span class="article-type">{{item.readTypeName}}</span>
                <span class="gray-color">{{ item.classificationText }}</span>
              </div>
              <img class="icon" :src="getBrandImageUrl('gray_right_arrow.png')" alt="" />
            </div>
            <div class="flex-row justify-between align-center">
              <div class="flex-column">
                <span class="display-inline-block mb-2" style="word-break: break-all">{{ item.title }}</span>
                <span class="common-color2">{{ item.titleTranslation }}</span>
              </div>
              <img
                v-if="item.lock == 1"
                class="icon"
                :src="getBrandImageUrl('reading/locked_icon.png')"
                alt=""
              />
              <img
                v-if="item.lock == 2"
                class="icon"
                :src="getBrandImageUrl('reading/unlock_icon.png')"
                alt=""
              />
            </div>
          </div>
          <!--          <ion-content>-->
          <!--            <ion-infinite-scroll-->
          <!--                @ionInfinite="loadData($event)"-->
          <!--                threshold="100px"-->
          <!--                id="infinite-scroll"-->
          <!--                :disabled="isDisabled">-->
          <!--              <ion-infinite-scroll-content-->
          <!--                  loading-spinner="bubbles"-->
          <!--                  loading-text="数据加载中...">-->
          <!--              </ion-infinite-scroll-content>-->
          <!--            </ion-infinite-scroll>-->
          <!--          </ion-content>-->
        </div>
      </template>
    </page-white-background>
  </ion-page>
</template>
<script>
import {
  actionSheetController,
  IonPage,
  IonContent,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonSearchbar,
  modalController,
} from "@ionic/vue";

import PageWhiteBackground from "@/components/PageWhiteBackground.vue";
import { documentTextOutline, filmOutline, chevronBackOutline } from "ionicons/icons";
import NewReadingArticle from "@/views/reading/newReadingArticle/ArticleIndex.vue";
import { BRAND_IMAGES, getBrandImageUrl } from "@/js/brandImages.ts";
import ReadingArticle from "@/views/reading/ReadingArticle.vue";

export default {
  name: "ReadingIndex",
  components: {
    IonPage,
    IonSearchbar,
    PageWhiteBackground,
  },
  props: ["courseId"],
  setup() {
    return {
      documentTextOutline,
      filmOutline,
      chevronBackOutline,
    };
  },
  data() {
    return {
      dataList: [],
      isDisabled: false,
      queryForm: {
        pageNum: 1,
        pageSize: 9999,
        title: undefined,
        studentId: undefined,
      },
      brandImages: BRAND_IMAGES,
    };
  },

  mounted() {
    this.userinfo = this.store.getUser();
    this.queryReadingArticle();
  },
  methods: {
    getBrandImageUrl,
    //查询阅读理解文章
    queryReadingArticle(courseId) {
      const appointment = this.store.getAppointment();
      this.queryForm.classificationId = courseId
        ? courseId
        : this.courseId
          ? this.courseId
          : appointment.courseId;
      this.queryForm.studentId = appointment.studentId;
      this.ajax.post("/reading/queryReadingForAppV1", this.queryForm).then((res) => {
        if (res.data.success) {
          const page = res.data.page;
          if (page.list) {
            page.list.forEach((obj) => {
              this.dataList.push(obj);
            });
          }
          this.queryForm.pageNum++;
        }
      });
    },

    searchReadingArticle(e) {
      this.queryForm.title = e.detail.value;
      this.queryForm.pageNum = 1;
      if (this.queryForm.title) {
        this.queryForm.title = this.queryForm.title.trim();
        if ("" == this.queryForm.title) {
          this.queryForm.title = undefined;
        }
      }

      this.dataList = [];
      this.queryReadingArticle();
    },

    async openReadingArticle(item) {
      if (item.lock == 1) {
        return;
      }
      if (
        (this.store.getAppointment().courseName.includes("完型") && !item.readType) ||
        (item.readType !== 1 && item.readType !== 2)
      ) {
        // 3.0阅读理解
        const modal = await modalController.create({
          component: ReadingArticle,
          componentProps: { readingId: item.readingId },
          cssClass: "modal_controller_class",
        });
        await modal.present();
        const { data } = await modal.onDidDismiss();
        if ("FINISHED" === data) {
          this.doRefresh();
        }
      } else {
        // 4.0阅读理解
        const modal = await modalController.create({
          component: NewReadingArticle,
          componentProps: { readingId: item.readingId },
          cssClass: "modal_controller_class",
        });
        await modal.present();
        const { data } = await modal.onDidDismiss();
        if ("FINISHED" === data) {
          this.doRefresh();
        }
      }
    },

    async openCourseModel() {
      const typeId = this.store.getAppointment().courseTypeId;
      const studentId = this.store.getAppointment().studentId;
      try {
        const res = await this.ajax.get(
          "/reading/queryMyReadingDetails?typeId=" + typeId + "&studentId=" + studentId
        );
        if (res.data.success) {
          const list = res.data.data;
          const trialButtons = [];
          let that = this;
          list.forEach((item) => {
            let obj = {
              text: item.coursePersonal.courseName,
              handler: () => {
                that.queryReadingArticle(item.coursePersonal.courseId);
              },
            };
            trialButtons.push(obj);
          });
          trialButtons.push({ text: "取消", role: "cancel" });

          const actionSheet = await actionSheetController.create({
            header: "选择词库",
            buttons: trialButtons,
          });
          await actionSheet.present();
          const { data } = await actionSheet.onDidDismiss();
        }
      } catch (err) {}
    },

    doRefresh(RefreshAnimationEvent) {
      if (RefreshAnimationEvent) {
        RefreshAnimationEvent.target.complete();
      }
      this.queryForm.pageNum = 1;
      this.dataList = [];
      this.queryReadingArticle();
    },

    loadData(ev) {
      this.queryReadingArticle();
      ev.target.complete();
    },
  },
};
</script>
<style scoped lang="less">
@import "@/assets/common.less";

.reading {
  width: 100%;
  height: 100%;
  list-style: none;

  &_page {
    width: 100%;
    height: 100%;

    .search-bar {
      border-radius: 5vw;
      overflow: hidden;
      --border-radius: 5vw;
      --box-shadow:
        0 0px 0px 0 rgba(0, 0, 0, 0.14), 0 0px 0px 0px rgba(0, 0, 0, 0.2),
        0 1px 5px 0 rgba(0, 0, 0, 0.12);
    }

    &-card {
      width: 100%;
      background-color: var(--page-bg-color);
      border-radius: 2vw;
      padding: 3vw;
    }
    .article-type {
      //1px = 0.13vw
      background: linear-gradient(90deg, #ff9c39 0%, #fe7b1b 100%);
      color: white;
      margin-right: 2.3vw;
      padding: 0.3vw 0.73vw;
      font-size: 3vw;
      border-radius: 0.52vw;
    }

    .list-title {
      width: 100%;
      word-break: break-all;
    }
  }
}
</style>
